/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

// The "Share in chat" seam (AC-12.4): any non-chat component (the annotation panel, a future
// image-list action, …) can open the chat share picker without importing chat internals — it just
// emits on the app's existing global `$eventBus` (installed on `Vue.prototype` in main.js; the
// same bus App.vue already uses for `viewer-toggle-top-menu`). Chat listens once, from ChatWindow.
//
// Payload matches the contract's `SharePayload` — `{kind: 'wsi'|'region'|'annotation', ref,
// deep_link, thumb}` (AC-12.1/12.5) — built by the caller from whatever domain object it owns
// (e.g. an `Annotation` model's `annotationCropURL()` for `thumb`); chat never resolves it itself.
export const SHARE_IN_CHAT_EVENT = 'chat-share-in-chat';

export function shareInChat(eventBus, sharePayload) {
  eventBus.$emit(SHARE_IN_CHAT_EVENT, sharePayload);
}
